import { render, staticRenderFns } from "./create-license.vue?vue&type=template&id=488a252c&"
import script from "./create-license.vue?vue&type=script&lang=js&"
export * from "./create-license.vue?vue&type=script&lang=js&"
import style0 from "./create-license.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports